module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/Pages/tasks/newpatient/newpatient.component.css
// module id = ./src/app/Pages/tasks/newpatient/newpatient.component.css
// module chunks = main